import React, { Fragment } from 'react'
import { FormTextArea, FormDisplayErrors } from '@myxplor/forms'
import RemoteTypeAheadSelect from '../../../ui/forms/type-ahead'
import { Note } from '@myxplor/ui'

export const ForceSubmissionFields = ({ values, errors, onChange, child_id, service_id }) => (
  <fieldset>
    <legend>Force Submissions</legend>
    <div className="Submissions_InfoWrapper">
      <Note important>
        <div>
          This action will attempt to submit for this week against a ceased enrolment.
          <br/>
          Submissions will only run if the enrolment was active for this week prior to becoming ceased.
        </div>
      </Note>
    </div>

    <RemoteTypeAheadSelect
      name="care_id"
      label="Xplor Profile"
      required
      hint="This is the Xplor Profile that has the bookings in Xplor that you wish to submit for. You can find this on the Enrolments page for the child."
      onChange={onChange}
      errors={errors.care_id}
      apiEndPoint={`/api/services/${service_id}/children/${child_id}/care-enrolments-options`}
    />

    <RemoteTypeAheadSelect
      name="enrolment_id"
      label="CCS Enrolment"
      required
      hint="This is the government issued Enrolment ID you wish to submit against. Make sure that this is the correct enrolment for the Xplor profile!"
      onChange={onChange}
      errors={errors.enrolment_id}
      apiEndPoint={`/api/services/${service_id}/children/${child_id}/ccs-enrolments-options`}
    />

    <div className="Submissions_InfoWrapper">
      <Note important>
        If you are creating a new submission after the 14-day limit or updating a submission after the
        28-day limit, you will need to provide a reason for the late change for assessment by the
        Department of Education and Training.
        <FormTextArea
          name="late_reason"
          label="Late Submission Reason"
          value={values.late_reason}
          errors={errors.late_reason}
          onChange={onChange}
          maxLength={1000}
          rows={2}
        />
      </Note>
    </div>
  </fieldset>
)

export const ForceSubmissionDone = ({ errors = [] }) =>
  errors.length > 0 ? (
    <Fragment>
      CCS Submissions have been run but there were some errors...
      <FormDisplayErrors errors={errors} />
    </Fragment>
  ) : (
    <Fragment>All CCS Submissions were successfully run</Fragment>
  )



// WEBPACK FOOTER //
// ./src/session-summaries/details/force-submissions/fields.jsx